// @ts-strict-ignore
import React, { useCallback, useEffect } from 'react'
import { useNavigation } from '@react-navigation/native'
import { useSelector } from 'APP/Hooks/redux'
import styled, { useTheme } from 'styled-components/native'

import Button from 'APP/Converse/Button'
import { Badge } from 'APP/Components/NotificationIconBadge/style'
import Analytics from 'APP/Services/Analytics'
import I18n from 'APP/I18n'
import { useDevTools } from 'APP/Lib/DevTools'

const IconWrapper = styled.View<{ isRegistrationPage?: boolean }>`
  position: relative;
  justify-content: center;
  align-items: center;
  ${({ isRegistrationPage, theme }) =>
    isRegistrationPage && `margin-right: ${theme.metrics.baseMargin}px;`}
`

const CustomBadge = styled(Badge)`
  position: absolute;
  top: 0;
  right: ${({ theme }) => theme.metrics.baseMargin * 1.8}px;
  min-width: ${({ theme }) => theme.metrics.baseMargin * 0.7}px;
  height: ${({ theme }) => theme.metrics.baseMargin * 0.7}px;
`

const SecondaryButton = styled(Button)`
  border: ${({ theme }) => theme.colors.buttonSecondaryOutline};
  text-transform: ${({ theme }) => theme.fonts.textTransform.button};
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
`

const HelpCentreIcon = styled(SecondaryButton)`
  padding: ${({ theme }) => theme.metrics.baseMargin - 3}px;
`

interface IntakeHelpCentreButtonProps {
  questionPost?: any
  screenName?: string
  isRegistrationPage?: boolean
}

const IntakeHelpCentreButton: React.FC<IntakeHelpCentreButtonProps> = ({
  questionPost,
  screenName,
  isRegistrationPage,
}) => {
  const theme = useTheme()
  const navigation = useNavigation()
  const unreadCount = useSelector((state) => state.zendesk.unreadCount)
  const { setHasHelpButton } = useDevTools()

  useEffect(() => {
    if (!isRegistrationPage) return
    setHasHelpButton(true)
  }, [isRegistrationPage, setHasHelpButton])

  const handleHelpCentreIconPress = useCallback(() => {
    const eventScreenName = questionPost?.props?.utterance || screenName

    Analytics.trackEvent('button_click', {
      button_value: 'Intake help',
      screen_name: eventScreenName,
    })

    const formattedScreenName = isRegistrationPage
      ? `Registration - ${eventScreenName}`
      : 'Intake'

    navigation.navigate('helpCentre', {
      episodeId: questionPost?.channel_id,
      isRegistrationPage,
      screenName: formattedScreenName,
    })
  }, [navigation, questionPost, screenName, isRegistrationPage])

  return (
    <IconWrapper isRegistrationPage={isRegistrationPage}>
      <HelpCentreIcon
        variant="secondary"
        onPress={handleHelpCentreIconPress}
        testID="INTAKE_HELP_CENTRE_BTN"
        accessibilityLabel={I18n.t('AccessibilityIcons.helpCentre')}
        iconPosition="left"
        icon="question-mark"
        iconVariant="materialIcons"
        widthVariant="content"
        iconSize={theme.metrics.icon.xsmall}
      />
      {unreadCount > 0 && <CustomBadge />}
    </IconWrapper>
  )
}

export default IntakeHelpCentreButton
